import Component from 'flarum/common/Component';
export default class Label extends Component {
  view(vnode) {
    let style = {};
    let className = ['UiKit-Label'];
    if (this.attrs.className) className.push(this.attrs.className);
    if (this.attrs.color) {
      style.backgroundColor = "#".concat(this.attrs.color);
      className.push('colored');
    }
    return m("span", {
      className: className.join(' '),
      style: style
    }, m("span", {
      className: "UiKit-Label-text"
    }, vnode.children));
  }
}
flarum.reg.add('sycho-uikit', 'common/components/Label', Label);